import {
  FsTournamentSegment,
  FsTournamentSegmentBase,
} from "db/model/tournament/Segment/FsTournamentSegment";
import { FsTournamentSegmentGroup } from "db/model/tournament/Segment/FsTournamentSegmentGroup";
import {
  TournamentSegment,
  TournamentSegmentBase,
} from "model/Tournament/Segment/TournamentSegment";
import { TournamentSegmentGroup } from "model/Tournament/Segment/TournamentSegmentGroup";
import { checkTypeExhausted, nonUndefined } from "Utility";
import { mapBracketSegment } from "./Bracket/FsBracket";
import { mapQualifierSegment } from "./Qualifier/FsQualifier";
import { mapSeasonSegment } from "./Season/FsSeason";
import { mapSwissSegment } from "./Swiss/FsSwiss";
import { mapSingleSegment } from "./TimeAttack/FsTimeAttack";

export const mapTournamentSegmentBase = <
  TType extends string,
  TFsGroup extends FsTournamentSegmentGroup,
  TGroup extends TournamentSegmentGroup
>(
  fsModel: FsTournamentSegmentBase<TFsGroup>,
  type: TType,
  mapGroups: (fsModels: TFsGroup[]) => TGroup[]
): TournamentSegmentBase<TType, TGroup> | undefined => {
  if (!fsModel.name || !fsModel.segmentId) {
    return undefined;
  }

  return {
    dqForceLast: fsModel.dqForceLast,
    dqRosterIds: fsModel.dqRosterIds,
    ffForceLast: fsModel.ffForceLast,
    ffRosterIds: fsModel.ffRosterIds,
    groups: mapGroups(fsModel.groups ?? []),
    message: fsModel.message,
    name: fsModel.name,
    segmentId: fsModel.segmentId,
    type,
  };
};

export const mapTournamentSegments = (
  fsModels: FsTournamentSegment[]
): TournamentSegment[] => {
  return nonUndefined(fsModels.map(mapTournamentSegment));
};

const mapTournamentSegment = (
  fsModel: FsTournamentSegment
): TournamentSegment | undefined => {
  if (fsModel.type === "Bracket") {
    return mapBracketSegment(fsModel);
  }

  if (fsModel.type === "Qualifier") {
    return mapQualifierSegment(fsModel);
  }

  if (fsModel.type === "Season") {
    return mapSeasonSegment(fsModel);
  }

  if (fsModel.type === "Single") {
    return mapSingleSegment(fsModel);
  }

  if (fsModel.type === "Swiss") {
    return mapSwissSegment(fsModel);
  }

  return checkTypeExhausted(fsModel);
};
